export default "__VITE_ASSET__C0ey6jj2__"